import * as accounting from './accounting';
import * as admin from './admin';
import * as backfill from './backfill';
import * as cart from './cart';
import * as company from './company';
import * as compliance from './compliance';
import * as CRM from './CRM';
import * as featureEnrollment from './feature-enrollment';
import * as inventory from './inventory';
import * as categoryManagement from './inventoryInsights';
import * as logistics from './logistics';
import * as order from './order';
import * as pricing from './pricing';
import * as replenishment from './replenishment';
import * as reports from './reports';
import * as s2s from './s2s';
import * as settings from './settings';
import * as shipAssist from './shipAssist';
import * as shop from './shop';
import * as traceability from './traceability';
import * as trustedSeller from './trustedSeller';
import * as user from './user';
import * as utils from './utils';
import * as utm from './utm';
import * as warehouse from './warehouse';

/**
 * LeafLink API v2 adapter.
 * @type {Object<tbd>}
 */
export default {
  accounting,
  admin,
  backfill,
  cart,
  categoryManagement,
  compliance,
  company,
  settings,
  CRM,
  featureEnrollment,
  inventory,
  order,
  pricing,
  logistics,
  replenishment,
  reports,
  s2s,
  shipAssist,
  shop,
  traceability,
  trustedSeller,
  user,
  utils,
  utm,
  warehouse,
};
